<template>
  <two-column-flow-layout :mobileWidth="1164">
    <template v-slot:left="{ isMobile }">
      <div class="mfu-column mx-auto right my-auto">
        <div class="d-flex mb-4 ml-4 justify-space-between">
          <div v-if="!mobileOnly" ref="header" class="text-h4 primary--text font-weight-bold">
            Welcome, {{ userName }}
          </div>
          <div v-if="isMobile && !mobileOnly" class="text-right">
            <o-btn v-if="isLoggedIn && !isCsr && userCanPost" @click="startQuery()">
              {{ $t("captions.askQuestion") }}
            </o-btn>
          </div>
        </div>
        <v-row>
          <v-col cols="12" v-if="isLnr && mobileOnly">
            <o-btn class="w-100" @click="startQuery()">{{ $t("captions.askQuestion") }}</o-btn>
          </v-col>
          <v-col
            cols="12"
            class="container-lg"
            :class="{ 'my-2': mediumScreen }"
            :style="!isMobile ? (mediumScreen ? '' : 'min-height:315px;') : undefined"
          >
            <upcoming-discussions-card
              :style="!isMobile ? getContainerheight : undefined"
              :userId="userId"
              :isMobile="isMobile"
              :mobileOnly="mobileOnly"
              :isExpert="isExpert"
              :isLnr="isLnr"
              :isLnrOrManager="isLnrOrManager"
            />
          </v-col>
        </v-row>
        <div
          v-if="isMobile && mobileOnly && isLoggedIn && !isCsr && userCanPost && !isLnr"
          class="d-flex container-lg flex-column mt-8"
        >
          <o-btn @click="startQuery()">{{ $t("captions.askQuestion") }} </o-btn>
        </div>
        <v-row class="mt-6">
          <v-col
            cols="12"
            sm="6"
            class="container-sm"
            :class="{ 'medium-screen my-2': mediumScreen }"
            v-show="cmsTiles.tile1"
          >
            <cms-rich-tile-card
              contentField="tile_1_content"
              :document="currentDocument"
              :height="cmsHeight"
              :isMobile="isMobile"
              @loaded="cmsTiles.tile1 = $event"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="container-sm"
            :class="[isXs ? 'mt-2' : '', mediumScreen ? 'medium-screen my-2' : '']"
            v-show="cmsTiles.tile2"
          >
            <cms-rich-tile-card
              contentField="tile_2_content"
              :document="currentDocument"
              :height="cmsHeight"
              :isMobile="isMobile"
              @loaded="cmsTiles.tile2 = $event"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:right="{ isMobile }">
      <div :class="{ 'mfu-column mx-auto left': true, 'mt-8': isMobile }">
        <div v-if="!isMobile" class="text-right mb-4" :style="{ height: headerHeight + 'px' }">
          <o-btn v-if="isLoggedIn && !isCsr && userCanPost" @click="startQuery()">
            {{ $t("captions.askQuestion") }}
          </o-btn>
        </div>
        <v-row>
          <v-col
            cols="12"
            class="container-md"
            :class="{ 'medium-screen my-2': mediumScreen }"
            v-show="cmsTiles.tile3"
          >
            <cms-rich-tile-card
              contentField="tile_3_content"
              :height="cmsHeight"
              :document="currentDocument"
              :isMobile="isMobile"
              @loaded="cmsTiles.tile3 = $event"
            />
          </v-col>
        </v-row>
        <v-row :class="{ 'mt-6': cmsTiles.tile3, 'mt-3': !cmsTiles.tile3 && userCanPost }">
          <v-col class="container-lg" :class="{ 'my-2': mediumScreen }" cols="12">
            <query-stats-card v-if="!isLnrOrManager" :userId="userId" :isExpert="isExpert" />
            <past-discussion v-else :userId="userId" :isExpert="isExpert" :isManager="isManager" />
            <o-sheet v-if="isLnrOrManager" class="mt-4 info-text-2">
              <h2>{{ isLnr ? $t("captions.resources") : $t("captions.learners") }}</h2>
              <div class="d-flex justify-space-between align-center">
                <span>{{ isLnr ? $t("captions.resourcesCaption") : $t("captions.learnersCaption") }}</span>
                <o-btn variant="info2" :to="memberfileRedirection" outlined small>{{ $t("captions.view") }}</o-btn>
              </div>
            </o-sheet>
          </v-col>
        </v-row>
      </div>
    </template>
  </two-column-flow-layout>
</template>

<script lang="ts">
import Vue, { VueConstructor } from "vue";
import TwoColumnFlowLayout from "@/components/layout/TwoColumnFlowLayout.vue";
import UpcomingDiscussionsCard from "./components/UpcomingDiscussionsCard.vue";
import QueryStatsCard from "./components/QueryStatsCard.vue";
import CmsRichTileCard from "@/components/util/CmsRichTileCard.vue";
import CommonButton from "@/components/form/CommonButton.vue";
import OBtn from "@/framework/OBtn.vue";
import OSheet from "@/framework/OSheet.vue";
import { UserType } from "@/config";
import { ChatBotEvent } from "@/service";
import { CloningQueryDetails } from "@/store/query/types";

import { RootStoreInterface } from "@/store/types";
import { DashboardStoreInterface } from "@/store/dashboard/types";
import { createHelpers } from "vuex-typescript-interface";
import PastDiscussion from "./components/PastDiscussion.vue";
import { QueryStoreInterface } from "@/store/query/types";

const {  mapMutations: mapQueryMutations } = createHelpers<QueryStoreInterface>();
const queryMutations = mapQueryMutations(["setClonedQueryDetails"])

const { mapGetters } = createHelpers<RootStoreInterface>();
const { mapGetters: mapDocGetters, mapActions: mapDocActions } = createHelpers<DashboardStoreInterface>();

const getters = mapGetters(["user", "userTypes", "currentLocale", "isLoggedIn", "activeUserType", "userCanPost", "getDefaultDraftId"]);
const docGetters = mapDocGetters(["currentDocument"]);
const docActions = mapDocActions(["loadCms"]);

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        header: InstanceType<typeof HTMLElement>;
      };
    }
  >
).extend({
  components: {
    TwoColumnFlowLayout,
    UpcomingDiscussionsCard,
    QueryStatsCard,
    CmsRichTileCard,
    CommonButton,
    OBtn,
    PastDiscussion,
    OSheet,
  },
  data: () => ({
    docType: "onviv-portal-dashboard",
    cmsTiles: {
      tile1: false,
      tile2: false,
      tile3: false,
    },
    headerHeight: 0,
    loading: false,
  }),
  computed: {
    ...getters,
    ...docGetters,
    userId(): number {
      return this.user?.id ?? 0;
    },
    isExpert(): boolean {
      return this.user?.noeticExpert ?? false;
    },
    isCsr(): boolean {
      return this.activeUserType == UserType.CSR;
    },
    isLnr(): boolean {
      return this.activeUserType == UserType.LEARNER;
    },
    isManager(): boolean {
      return this.activeUserType == UserType.PLAN_MANAGER;
    },
    isLnrOrManager(): boolean {
      return this.isLnr || this.isManager;
    },
    userName(): string {
      return this.user?.resolvedDisplayName ?? "";
    },
    isXs(): boolean {
      return this.$vuetify.breakpoint.xs;
    },
    isMobile(): boolean {
      // True when the viewport is under the breakpoint for mobile behavior
      return this.$vuetify.breakpoint.width < 1420;
    },
    mobileOnly(): boolean {
      // True when the viewport is under the breakpoint for mobile behavior
      return this.$vuetify.breakpoint.smAndDown;
    },
    cmsHeight(): number | undefined {
      return !this.isMobile ? (this.mediumScreen ? 220 : 210) : undefined;
    },
    mediumScreen(): boolean {
      return this.$vuetify.breakpoint.width >= 1164 && this.$vuetify.breakpoint.width <= 1419;
    },
    getContainerheight(): string | undefined {
      // TODO: update the whole dashboard structure with dynamic height (currenlty following the existing static  height flow)
      return this.isLnrOrManager ? "height:441px" : "height: 290px";
    },
    memberfileRedirection(): string {
      return this.isLnr ? "/member/files" : "/assigned-learners";
    },
    hasDefaultDraft(): boolean {
      return this.getDefaultDraftId !== null && this.getDefaultDraftId !== undefined && this.getDefaultDraftId > 0;
    },
  },
  methods: {
    ...docActions,
    ...queryMutations,
    startQuery() {
      if(!this.hasDefaultDraft) {
        this.setClonedQueryDetails(null);
        this.$router.push({ name: "NewQuery" });
        return;
      }
        const clonedQuery = {
          cloneFlag: true,
          cloneSource: ChatBotEvent.cloneSource.DRAFT,
          cloneId: this.getDefaultDraftId,
          cloningValue: false
        } as CloningQueryDetails
        this.setClonedQueryDetails(clonedQuery);

        this.$nextTick(() => {
          this.$router.push({ name: "NewQuery" });
        });
    },
    calculateHeaderHeight() {
      this.$nextTick(() => {
        if (this.$refs.header) {
          this.headerHeight = this.$refs.header.clientHeight;
        }
      });
    },
  },
  watch: {
    mobileOnly(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(this.calculateHeaderHeight);
      }
    },
  },
  created() {
    this.loadCms(this.docType);
  },
  mounted() {
    this.calculateHeaderHeight();
    window.addEventListener("resize", this.calculateHeaderHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateHeaderHeight);
  },
});
</script>

<style lang="scss" scoped>
:deep(.tcf) {
  @media only screen and (min-width: 1420px) and (min-height: 750px) {
    top: 50% !important;
    margin-top: -300px !important;
  }
}

.info-text-2 {
  color: #284489;
}

.mfu-column {
  height: 100%;
  position: relative;
  padding: 0 20px;

  @media only screen and (min-width: 768px) {
    width: 752px;
  }

  @media only screen and (min-width: 1420px) {
    width: 694px;

    &.left {
      margin-left: 0px !important;
      margin-right: auto !important;
    }
    &.right {
      margin-left: auto !important;
      margin-right: 0px !important;
    }
  }
}

@media (min-width: 1164px) and (max-width: 1419.6px) {
  :deep(.tcf-left) {
    padding-right: 16px !important;
  }

  :deep(.tcf-right) {
    padding-left: 12px;
  }

  .container-lg {
    width: 100%;
    min-height: 220px;
  }

  .container-md {
    width: 100%;
    min-height: 160px;
  }

  .container-sm {
    max-height: 160px;
  }

  .mfu-column {
    max-width: 100%;
  }
}
</style>
